<div class="offline-container">
  <div class="offline-icon">
    <i class="bx bx-wifi-off"></i>
  </div>

  <h1 class="offline-heading">You're offline</h1>
  <p class="offline-message">
    This page can't be displayed because your device isn't connected to the internet.
  </p>
  <p class="offline-hint">We'll bring you right back once your connection returns.</p>

  <button type="button" class="offline-retry-btn" (click)="retry()">
    <i class="bx bx-refresh"></i>
    Try Again
  </button>
</div>
